package com.essntl.features.itinerary.domain.model

sealed class ItineraryServiceOrderType(val orderName: String) {
    data object Client : ItineraryServiceOrderType("Traveller")
    data object StartTime : ItineraryServiceOrderType("Time")
    data object Status : ItineraryServiceOrderType("Status")
    data object StartDate : ItineraryServiceOrderType("Date")
    data object StartDateStartTime : ItineraryServiceOrderType("Date and time")
    companion object {
        val Default = StartTime
    }
}
